export default __webpack_public_path__ + "static/media/markdown_ico.f8b69eb3.svg";